import React from 'react';
import { Save } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { sectionSchema, type SectionFormValues } from '../schemas/lessonSchema';

interface AddSectionFormProps {
  onSave: (title: string) => Promise<void>;
  onCancel: () => void;
  isSaving: boolean;
}

const AddSectionForm: React.FC<AddSectionFormProps> = ({ onSave, onCancel, isSaving }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SectionFormValues>({
    resolver: zodResolver(sectionSchema),
    defaultValues: { title: '' },
  });

  const onSubmit = async (data: SectionFormValues) => {
    await onSave(data.title);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form-card" style={{ marginBottom: '20px' }}>
      <div className="form-row">
        <div className="form-group" style={{ flex: 1 }}>
          <label>Section Title *</label>
          <input
            type="text"
            {...register('title')}
            placeholder="e.g., Introduction to Programming"
            className="form-input"
          />
          {errors.title && (
            <span style={{ color: '#d32f2f', fontSize: '12px' }}>{errors.title.message}</span>
          )}
        </div>
      </div>
      <div className="form-actions">
        <button type="submit" disabled={isSaving} className="btn-primary">
          <Save size={18} />
          {isSaving ? 'Saving...' : 'Save Section'}
        </button>
        <button type="button" onClick={onCancel} className="btn-secondary">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddSectionForm;
